import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CancelButton, NudgeImage, NudgeLayout, UpgradeButton, } from "@zapier/upsells/esm/components";
import { upgradeReasons } from "@zapier/upsells/esm/types";
import { getActiveView } from "./getActiveView";
export const EmailSupportUpgradeNudge = ({ onClose, onUpgradeClick, }) => {
    const activeView = getActiveView();
    return (_jsx(NudgeLayout, { bodyText: activeView.bodyText, buttons: [
            _jsx(CancelButton, { onClick: onClose }, "cancel"),
            _jsx(UpgradeButton, { onClick: onUpgradeClick }, "upgrade"),
        ], headingText: "Upgrade to contact Support", id: "email-support", image: _jsx(NudgeImage, { type: upgradeReasons.emailSupport }), subtitleText: "Premium" }));
};

// @zapier/upsells@8.0.1 (466b4077f)
